import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Modal, Row, Upload } from 'antd';
import { toast } from 'react-toastify';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { UploadOutlined } from '@ant-design/icons';
import { ResponseDataType, postRequest } from 'api';
import { useAppContext } from 'Context/AppContext';
import styles from '../../bill.module.css';

interface FormValueType {
  file: any;
}

export const CreateNewBill = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { setTabNumber } = useAppContext();

  const HandleInputFile = (value: FormValueType) => {
    Modal.confirm({
      style: { fontFamily: 'Quicksand' },
      title: 'Xác nhận thêm biên lai.',
      async onOk() {
        const formData = new FormData();
        formData.append('file', value.file[0].originFileObj);

        const response: ResponseDataType<any> = await postRequest('/cms/invoice/import-invoices-excel', formData, 'form-data');
        if (response && response.code === 200) {
          toast.success('Thêm biên lai thành công! Biên lai đã được chuyển vào Danh sách chờ duyệt.');
          form.resetFields();
          navigate('/pending-approval-bill-list');
        } else {
          toast.error(response?.msg || 'Thêm biên lai thất bại!');
          // Chuyển sang tab lỗi nếu import có lỗi
          setTabNumber(2);
        }
      },
    });
  };

  return (
    <div>
      <Card title="Thêm biên lai bán trú" className={styles.bill_info_card}>
        <Form form={form} onFinish={HandleInputFile}>
          <Row>
            <Col span={8}>
              <div className={styles.card_content_label}>
                <InsertDriveFileIcon />
                &nbsp;&nbsp;File:
              </div>
            </Col>
            <Col span={16}>
              <Form.Item
                name="file"
                valuePropName="fileList"
                getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
                rules={[
                  { required: true, message: 'Cần nhập file!' },
                  {
                    validator: (_, value) =>
                      value && value.length > 0 && /\.(xlsx|xls)$/i.test(value[0].name)
                        ? Promise.resolve()
                        : Promise.reject(new Error('Chỉ chấp nhận file Excel!')),
                  },
                ]}
              >
                <Upload beforeUpload={() => false}>
                  <Button icon={<UploadOutlined />}>Chọn file</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Button type="primary" htmlType="submit">
            IMPORT FILE
          </Button>
        </Form>
      </Card>
    </div>
  );
};
